/* @ngInject */

import { default as FEATURES } from '../common/feature-enum';
import { default as USER_CLAIMS } from '../common/claim-enum';
import { shouldBeEnabled } from '../common/common'

export default class MegaNavCtrl {
  constructor(
    $q,
    $scope,
    $state,
    $window,
    $timeout,
    $location,
    $rootScope,
    $anchorScroll,
    LocalStorageService,
    NotificationService,
    AuthorizationService,
    AuthenticationService,
    CommonService
  ) {
    this.$q = $q;
    this.$scope = $scope;
    this.$state = $state;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$anchorScroll = $anchorScroll;
    this.LocalStorageService = LocalStorageService;
    this.NotificationService = NotificationService;
    this.AuthorizationService = AuthorizationService;
    this.AuthenticationService = AuthenticationService;
    this.CommonService = CommonService;
    this.shouldBeEnabled = shouldBeEnabled;

    this.isBusy = false;
    this.init();
    this.activate();
  }

  _addMyProfile() {
    this.$rootScope.$eval(() => {
      const myProfileIsAllowed = this.shouldBeEnabled(USER_CLAIMS.MY_PROFILE)

      if (myProfileIsAllowed) {
        const oldMenuLink = this.menuLinks.find(
          menu => menu === USER_CLAIMS.MY_PROFILE
        );

        if (!!!oldMenuLink) {
          this.menuLinks.push(USER_CLAIMS.MY_PROFILE);
        }
      } else {
        const newMenuLinks = this.menuLinks.filter(
          menu => menu !== FEATURES.MY_PROFILE
        );
        this.menuLinks = newMenuLinks;
      }
    });
  }

  init() {
    this.friendlyName = '';
    this.authorize = false;
    this.authorized = false;
    this.menuLinks = ['Dashboard'];

    this._addMyProfile();

    this.$rootScope.$on('user-logged-in', ($event, results) => {
      this.gotUser(results);
    });

    this.$rootScope.$on('user-login-busy', ($event, { err, isBusy }) => {
      this.isBusy = isBusy;
      if (err) {
        this.NotificationService.error('ERROR WHILE LOGIN IN', err, 3000);
      }
    });

    this.$rootScope.$on('selected-building-changed', () => {
      this._addMyProfile();
    });
  }

  activate() {
    const currentUser = this.AuthenticationService.currentUser();
    if (currentUser) {
      this.gotUser(currentUser);
    }
    else {
      this.redirectedFrom();
    }
  }

  async redirectedFrom() {
    const redirectedFrom = this.CommonService.QueryString('redirectedFrom');
    
    if (redirectedFrom == 'confirm-email') {

      this.$timeout(() => {
        this.showLogin();
      });

      this.CommonService.DeleteQueryStringParameter('redirectedFrom');
    }
    else if(redirectedFrom == 'levy-invoice'){
      this.$timeout(() => {
        this.showLogin();
      });

      this.CommonService.DeleteQueryStringParameter('redirectedFrom');
    }
  }

  linkClicked(evt) {
    const myProfileLink = 'my-profile';
    const linkText = evt.target.innerText.toLowerCase();
    let url = `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/`;

    if (linkText === 'logout') {
      this.LocalStorageService.clear("FullSite");
    } else if (linkText === myProfileLink.replace('-', ' ')) {
      const landingPage = 'dashboard';
      const currentPath = this.$location.absUrl();

      if (currentPath.includes(myProfileLink)) {
        return;
      }

      if (currentPath.indexOf(landingPage) !== -1) {
        this.$timeout(() => {
          this.$state.go(myProfileLink);
          return;
        });
        return;
      } else {
        url += `dashboard/?tab=6`;
      }
    } else {
      url += linkText;
    }

    this.$window.location.href = url;
  }

  gotoContactUs() {
    const $contactUsSection = $('#contact-us-section');

    if ($contactUsSection && $contactUsSection.length > 0) {
      $('#FullName').focus();
      $('html, body').animate(
        {
          scrollTop: $contactUsSection.offset().top
        },
        1000
      );
    }
    return false;
  }

  showLogin() {
    this.$rootScope.$broadcast('show-login-auth-modal');
  }

  gotUser(results) {
    if (results && results.length > 0) {
      const profile = results[1];
      if (profile.UserName) {
        this.friendlyName = profile.FullName;
        this.authorized = true;
      }
    } else if (typeof results == 'object') {
      this.authorized = true;
      this.friendlyName = results['FullName'];
    }
  }
}
